import { useState } from "react";
import { Plus, Trash2, Star } from "lucide-react";

const EMPTY = { name: "", price: "", category: "Primi Piatti Pronti", image: "", ingredients: "", weight: "", shelf_life: "", preparation: "" };

export const AdminProductsTab = ({ products, onPatch, onDelete, onCreate }) => {
  const [newProd, setNewProd] = useState(EMPTY);
  const [showAdd, setShowAdd] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const ok = await onCreate({ ...newProd, price: parseFloat(newProd.price) });
    if (ok) {
      setNewProd(EMPTY);
      setShowAdd(false);
    }
  };

  return (
    <div>
      <button data-testid="admin-add-product-btn" onClick={() => setShowAdd(!showAdd)} className="btn-tuscan inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold mb-6">
        <Plus className="w-4 h-4" /> Nuovo prodotto
      </button>
      {showAdd && (
        <form onSubmit={submit} className="rounded-2xl border border-[#E7E0D8] bg-white p-6 mb-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          <input data-testid="new-product-name" required placeholder="Nome *" value={newProd.name} onChange={(e) => setNewProd({ ...newProd, name: e.target.value })} className="rounded-xl border border-[#E7E0D8] px-4 py-3 text-sm" />
          <input data-testid="new-product-price" required type="number" step="0.01" min="0.01" placeholder="Prezzo € *" value={newProd.price} onChange={(e) => setNewProd({ ...newProd, price: e.target.value })} className="rounded-xl border border-[#E7E0D8] px-4 py-3 text-sm" />
          <select data-testid="new-product-category" value={newProd.category} onChange={(e) => setNewProd({ ...newProd, category: e.target.value })} className="rounded-xl border border-[#E7E0D8] px-4 py-3 text-sm bg-white">
            <option>Primi Piatti Pronti</option><option>Sughi Pronti</option><option>Gluten Fit</option>
          </select>
          <input data-testid="new-product-image" placeholder="URL immagine" value={newProd.image} onChange={(e) => setNewProd({ ...newProd, image: e.target.value })} className="rounded-xl border border-[#E7E0D8] px-4 py-3 text-sm" />
          <textarea data-testid="new-product-ingredients" placeholder="Ingredienti (allergeni tra [PARENTESI QUADRE])" value={newProd.ingredients} onChange={(e) => setNewProd({ ...newProd, ingredients: e.target.value })} className="md:col-span-2 rounded-xl border border-[#E7E0D8] px-4 py-3 text-sm" rows={2} />
          <input placeholder="Peso (es. 270 gr)" value={newProd.weight} onChange={(e) => setNewProd({ ...newProd, weight: e.target.value })} className="rounded-xl border border-[#E7E0D8] px-4 py-3 text-sm" />
          <input placeholder="Shelf life" value={newProd.shelf_life} onChange={(e) => setNewProd({ ...newProd, shelf_life: e.target.value })} className="rounded-xl border border-[#E7E0D8] px-4 py-3 text-sm" />
          <button data-testid="new-product-submit" type="submit" className="md:col-span-2 btn-tuscan py-3.5 rounded-full text-sm font-semibold">Crea prodotto</button>
        </form>
      )}
      <div className="overflow-x-auto rounded-2xl border border-[#E7E0D8] bg-white">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[#E7E0D8] text-left font-mono-accent text-[10px] uppercase tracking-[0.15em] text-[#78716C]">
              <th className="p-4">Prodotto</th><th className="p-4">Categoria</th><th className="p-4">Prezzo €</th><th className="p-4">Disponibile</th><th className="p-4">In evidenza</th><th className="p-4"></th>
            </tr>
          </thead>
          <tbody>
            {products.map((p) => (
              <tr key={p.slug} data-testid={`admin-product-row-${p.slug}`} className="border-b border-[#E7E0D8] last:border-0">
                <td className="p-4">
                  <div className="flex items-center gap-3">
                    <img src={p.image} alt="" className="w-10 h-10 rounded-lg object-cover" />
                    <span className="font-medium">{p.name}</span>
                  </div>
                </td>
                <td className="p-4 text-[#78716C]">{p.category}</td>
                <td className="p-4">
                  <input
                    data-testid={`admin-price-input-${p.slug}`}
                    type="number" step="0.01" min="0.01" defaultValue={p.price}
                    onBlur={(e) => { const v = parseFloat(e.target.value); if (v && v !== p.price) onPatch(p.slug, { price: v }); }}
                    className="w-24 rounded-lg border border-[#E7E0D8] px-3 py-1.5"
                  />
                </td>
                <td className="p-4">
                  <button
                    data-testid={`admin-toggle-available-${p.slug}`}
                    onClick={() => onPatch(p.slug, { available: !p.available })}
                    className={`w-12 h-6 rounded-full relative transition-colors ${p.available ? "bg-[#3C6E53]" : "bg-[#E7E0D8]"}`}
                  >
                    <span className={`absolute top-0.5 w-5 h-5 rounded-full bg-white transition-all ${p.available ? "left-6" : "left-0.5"}`} />
                  </button>
                </td>
                <td className="p-4">
                  <button
                    data-testid={`admin-toggle-featured-${p.slug}`}
                    onClick={() => onPatch(p.slug, { featured: !p.featured })}
                    title={p.featured ? "Rimuovi da 'piatti del momento'" : "Mostra tra i 'piatti del momento'"}
                  >
                    <Star className={`w-5 h-5 transition-colors ${p.featured ? "fill-[#7DC242] text-[#7DC242]" : "text-[#D6D0C6] hover:text-[#7DC242]"}`} />
                  </button>
                </td>
                <td className="p-4">
                  <button data-testid={`admin-delete-${p.slug}`} onClick={() => onDelete(p.slug)} className="text-[#78716C] hover:text-[#2E8A57]"><Trash2 className="w-4 h-4" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
